import { useMemo, useState } from "react";
import type { UseStep2ViewModelParams, UseStep2ViewModelResult } from "../model/propertiesTypes";
import { formatCurrency } from "@/utils/format.utils";

/**
 * Step 2 ViewModel
 * Owns Step 2 UI state. This step only collects names and forwards to Step 3.
 */
export function useStep2ViewModel({
  addressData,
  propertyDetails,
  formData,
  onNext,
  onBack,
}: UseStep2ViewModelParams): UseStep2ViewModelResult {
  const [firstName, setFirstName] = useState(
    propertyDetails?.ownerInfo?.owner1FirstName || formData?.firstName || ""
  );
  const [lastName, setLastName] = useState(
    propertyDetails?.ownerInfo?.owner1LastName || formData?.lastName || ""
  );
  const isSubmitting = false;

  const addressString = useMemo(
    () => addressData?.addressString || "694 Center St, Chicopee, MA",
    [addressData?.addressString]
  );

  const totalTaxBill = propertyDetails?.taxInfo?.taxAmount;
  const savingsAmount = useMemo(() => {
    return totalTaxBill ? Math.round(Number(totalTaxBill) * 0.08) : 0;
  }, [totalTaxBill]);

  const handleSubmit: UseStep2ViewModelResult["handleSubmit"] = async (e) => {
    e.preventDefault();
    if (!onNext) return;
    onNext({ firstName: firstName.trim(), lastName: lastName.trim() });
  };

  const handleBackClick = () => {
    if (onBack) onBack();
  };

  return {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    isSubmitting,
    addressString,
    savingsAmount: formatCurrency(savingsAmount as number),
    handleSubmit,
    handleBackClick,
  };
}
